import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppInformationService, AuthService, GenesisUnitOfWork, SessionInformationService } from 'app/core/core.module';
import { HistoryService } from 'app/core/history.service';
import { PurchaseOrder, PurchaseOrderStatus, Vendor } from 'app/core/model/entity-model';
import { SharedModule } from 'app/shared/shared.module';

@Component({
    selector: 'app-purchase-order-history',
    templateUrl: './purchase-order-history.component.html',
    styleUrls: ['./purchase-order-history.component.scss'],
    standalone: false
})
export class PurchaseOrderHistoryComponent implements OnInit {
    purchaseOrders: PurchaseOrder[];
    filter: any;
    vendors: Vendor[];
    statuses: PurchaseOrderStatus[];

    onExporting = SharedModule.onExporting;

    constructor(
        private uow: GenesisUnitOfWork,
        public auth: AuthService,
        private sessionInfo: SessionInformationService,
        private appInfo: AppInformationService,
        private router: Router,
        private historyService: HistoryService
    ) {}

    async ngOnInit() {
        this.vendors = await this.uow.getVendors();
        this.statuses = await this.uow.getPurchaseOrderStatuses();
        const filter = this.sessionInfo.getItem('purchase-order-history-filter');
        if (filter) {
            this.filter = filter;
            await this.search();
        } else this.filter = {};
    }

    async search() {
        this.appInfo.pleaseWaitShow();
        this.sessionInfo.setItem('purchase-order-history-filter', this.filter);
        this.purchaseOrders = await this.historyService.getPurchaseOrderHistory(this.filter);
        this.appInfo.pleaseWaitHide();
    }

    clear() {
        this.sessionInfo.removeItem('purchase-order-history-filter');
        this.filter = { includeDeleted: false };
    }

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift(
            {
                location: 'before',
                template: 'toolbarButtons',
            },
            {
                template: 'toolbarText',
                location: 'after',
            },
            {
                widget: 'dxButton',
                options: {
                    icon: 'revert',
                    elementAttr: { title: 'Reset Filters' },
                    onClick: () => {
                        e.component.clearFilter();
                    },
                },
                location: 'after',
            },
            {
                widget: 'dxButton',
                options: {
                    icon: 'refresh',
                    elementAttr: { title: 'Reset Grid Layout' },
                    onClick: () => {
                        e.component.state({});
                    },
                },
                location: 'after',
            }
        );
    }

    async open(orderId: number) {
        this.router.navigate(['/purchase-orders/' + (!!orderId ? orderId : 'new')]);
    }

    async rowDoubleClick(e) {
        if (!e.data || !e.data.id) return;
        await this.open(e.data.id);
    }
}
